import { render } from "./upcoming-delivery-batch.vue?vue&type=template&id=7a488e6b"
import script from "./upcoming-delivery-batch.vue?vue&type=script&lang=js"
export * from "./upcoming-delivery-batch.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__